import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
//utils
import queries from '../../../utils/queries';
import 'moment/locale/es';
var moment = require('moment');

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option dato1={props.elemento.consecProducto?props.elemento.consecProducto:0} 
    dato2={props.elemento.consecServicio?props.elemento.consecServicio:0} 
    dato3={props.elemento.consecPrograma?props.elemento.consecPrograma:0} 
    dato4={props.elemento.codEmpresa?props.elemento.codEmpresa:""}
    dato5={props.elemento.pais?props.elemento.pais:"Colombia"}>{props.elemento.descrEmpresa}</option>
  ) 
};

const ListaEmp = ({list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={handleLista}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS
const DetallePolNivel1 = props => {
  return (
    <option dato1={props.elemento.descrPolitica} dato2={props.elemento.tipoProducto} 
    dato3={props.elemento.titulo2?props.elemento.titulo2:""} 
    dato4={props.elemento.parrafo2?props.elemento.parrafo2:""} 
    dato5={props.elemento.titulo3?props.elemento.titulo3:""} 
    dato6={props.elemento.parrafo3?props.elemento.parrafo3:""} value={props.elemento.titulo}>{props.elemento.titulo}</option>

  ) 
};

const ListaPol = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetallePolNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="titulo" id="miLista1" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleConNivel1 = props => {
  return (
    <option dato1={props.elemento.ciudad?props.elemento.ciudad:""} dato2={props.elemento.cargo?props.elemento.cargo:""} dato3={props.elemento.email?props.elemento.email:""} dato4={props.elemento.telefono?props.elemento.telefono:""} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
    // <option dato1={props.elemento.ciudad} dato2={props.elemento.cargo} dato3={props.elemento.email} dato4={props.elemento.telefono} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaCon = ({list, handleLista}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleConNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreContacto" id="miLista3" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel3Detalle}
      </select>
    </div>
  )
};

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} 
    dato2={props.elemento.ciudad?props.elemento.ciudad:""} 
    dato3={props.elemento.email?props.elemento.email:""} 
    dato4={props.elemento.telefono?props.elemento.telefono:""} 
    value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  ) 
};

const ListaOpe = ({list, handleLista}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista2" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel4Detalle}
      </select>
    </div>
  )
};

const ListaEnt = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tiempoEntrega" id="miLista7" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>2-5 días hábiles</option>
        <option>6-9 días hábiles</option>
        <option>{">"} 10 días hábiles</option>
        <option>A convenir</option>
      </select>
    </div>
  )
};

const ListaPago = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="formaPago" id="miLista5" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Anticipado 100%</option>
        <option>Anticipo 50% contra entrega 50%</option>
        <option>Contra entrega 100%</option>
        <option>Pago {"="} 30 días</option>
        <option>Pago entre 30 {">="} y {"<"} 60 días</option>
        <option>Pago entre 60 {">="} y {"<"} 90 días</option>
        <option>Pago {">="} 90 días</option>
      </select>
    </div>
  )
};

const ListaOfer = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="validezOferta" id="miLista6" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>1 día</option>
        <option>3 días</option>
        <option>8 días</option>
        <option>15 días</option>
        <option>30 días</option>
        <option>60 días</option>
        <option>90 días</option>
      </select> 
    </div>
  )
};

const ListaMon = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="monedaCoti" id="miLista55" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Pesos</option>
        <option>Dolares</option>
      </select>
    </div>
  )
};
const ListaImp = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="imptoCoti" id="miLista77" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>IVA</option>
        <option>ITBMS</option>
      </select>
    </div>
  )
};
const ListaSN = ({nameLista, handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name={nameLista} id={nameLista} onChange={(ev)=>handleLista(ev, nameLista)}>
        <option>Seleccionar...</option>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};

// const AddProcEjec2 = ({this.props.styles, handleSubmit, handleChange, args, errors}) => {
  class AddCotizacion2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)

    let lista2 = []
    if(this.props.allUsuariosRtesExt.allUsuariosRtes){
      this.props.allUsuariosRtesExt.refetch()
      lista2 = this.props.allUsuariosRtesExt.allUsuariosRtes
    }
    let listRes = []
    if(this.props.allUsuariosRtesCom.allUsuariosRtes){
      this.props.allUsuariosRtesCom.refetch()
      listRes = this.props.allUsuariosRtesCom.allUsuariosRtes
    }

    let listCon=[]
    listCon = lista2.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
    let referencia = ''
    if(args.tipo==='Producto'){referencia = 'COTIZACION DE PRODUCTOS'}
    if(args.tipo==='Programa'){referencia = 'COTIZACION DE PROGRAMAS'}
    if(args.tipo==='Servicio'){referencia = 'COTIZACION DE SERVICIOS'}

    let ciudadEmpresa = ""
    if(this.props.getParametro.getParametro){
      ciudadEmpresa = this.props.getParametro.getParametro.empresaCiudad1?this.props.getParametro.getParametro.empresaCiudad1:""
    }
    moment.locale('es')    
    let fechaHoy = moment().format('LL')
    let ciudadFecha = ciudadEmpresa + ', ' + fechaHoy

    args.ciudadFechaEnvio=ciudadFecha
    args.referencia=referencia

    let listaEmp = []
    let labelFormaPago='Forma de pago'
    let labelComercial = 'Empresa'
    if(this.props.allEmpresaRtes.allEmpresaRtes){listaEmp = this.props.allEmpresaRtes.allEmpresaRtes}
    if(listaEmp.length>0){
      if(args.descrEmpresa){
        listaEmp = listaEmp.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
        if(listaEmp[0].ultimaFormaPago && listaEmp[0].ultimaFormaPago!=='' && listaEmp[0].ultimaFormaPago!==null){
          labelFormaPago='Forma de pago (' + listaEmp[0].ultimaFormaPago + ')'
        }
        if(listaEmp[0].comercialAtiende && listaEmp[0].comercialAtiende!=='' && listaEmp[0].comercialAtiende!==null){
          labelComercial='Empresa (Comercial que atiende: ' + listaEmp[0].comercialAtiende + ')'
        }
      }
    }


  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Cotización nueva
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                    <label style={this.props.styles.label}>Ciudad y fecha</label>
                    <Form.Input autoComplete="off" name="ciudadFechaEnvio" id="ciudadFechaEnvio" value={ciudadFecha} onChange={this.props.handleChange} placeholder='Ciudad y fecha' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'ciudadFechaEnvio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Responsable</label>
                  <ListaOpe list={listRes} handleLista={this.props.handleLista3} />
                </Form.Field>     
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  {/* <label style={this.props.styles.label}>Empresa</label> */}
                  <label style={this.props.styles.label}>{labelComercial}</label>
                  <ListaEmp list={this.props.list} handleLista={this.props.handleLista} />
                </Form.Field>
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={this.props.styles.label}>Contacto</label>
                  <ListaCon list={listCon} handleLista={this.props.handleLista2} />
                </Form.Field>                
              </div>
              <div className="column" width="50%">               
               <Form.Field>
                  <label style={this.props.styles.label}>Política comercial</label>
                  <ListaPol list={this.props.list1} handleLista={this.props.handleLista1} />
                </Form.Field>
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Referencia</label>
                  <Form.Input autoComplete="off" name="referencia" id="referencia" value={referencia} onChange={this.props.handleChange} placeholder='Referencia' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'referencia'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>   
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={this.props.styles.label}>Tiempo de entrega</label>
                  <ListaEnt styles={this.props.styles} handleLista={this.props.handleLista4} />
                </Form.Field>                                
                {/* <Form.Field>
                  <label style={this.props.styles.label}>Tiempo de entrega</label>
                  <Form.Input autoComplete="off" name="tiempoEntrega" id="tiempoEntrega" onChange={this.props.handleChange} placeholder='Tiempo de entrega' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'tiempoEntrega'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> */}
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Dirección exacta de entrega</label>
                  <Form.Input autoComplete="off" name="lugarEntrega" id="lugarEntrega" onChange={this.props.handleChange} placeholder='Dirección de entrega' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'lugarEntrega'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>{labelFormaPago}</label>
                  <ListaPago styles={this.props.styles} handleLista={this.props.handleLista5} />
                </Form.Field>
              </div>
              <div className="column" width="50%">     
                <Form.Field>
                  <label style={this.props.styles.label}>Validez de la oferta</label>
                  <ListaOfer styles={this.props.styles} handleLista={this.props.handleLista6} />
                </Form.Field>              
              </div>
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Moneda</label>
                  <ListaMon styles={this.props.styles} handleLista={this.props.handleLista55} />
                </Form.Field>
              </div>
              <div className="column" width="50%">     
                <Form.Field>
                  <label style={this.props.styles.label}>Impuesto a aplicar</label>
                  <ListaImp styles={this.props.styles} handleLista={this.props.handleLista77} />
                </Form.Field>              
              </div>
              <div className="column" style={{width: '50%'}}>
                <label style={this.props.styles.label}>Cliente en zona franca (Sin impuestos)</label>
                <Form.Field>
                  {/* <ListaSN styles={this.props.styles} nameLista='zonaFranca' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/> */}
                  <ListaSN nameLista='zonaFranca' handleLista={this.props.handleLista10}/>
                </Form.Field>
              </div>
              <div className="column" style={{width: '50%'}}>
                <label style={this.props.styles.label}>Gestionar ingreso</label>
                <Form.Field>
                  {/* <ListaSN styles={this.props.styles} nameLista='gestionIngreso' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/> */}
                  <ListaSN nameLista='gestionIngreso' handleLista={this.props.handleLista10}/>
                </Form.Field>
              </div> 
            </div>
          </div>
          <div className="row container">              
            <div className="column" width="100%">  
              <Form.Field>                
                <label style={this.props.styles.label}>Observaciones</label>
                <textarea name="observaciones" id="observaciones" cols="40" rows="3" onChange={this.props.handleChange}></textarea>                
              </Form.Field>
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: {$ne: 'XXXXXXX'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtesExt',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Externo'}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtesCom',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Comercial', estado: 'Activo'}}]`}}}}),


  )(AddCotizacion2)